import { Pipe, PipeTransform } from '@angular/core';

import * as utils from '../util';

@Pipe({
    name: 'capitalizefirstletterallwords',
    standalone: false
})
export class CapitalizeFirstLetterAllWords implements PipeTransform {
	transform(inputValue: string, args?: any): any {
		return utils.capitalizeNameAllWords(inputValue);
	}
}
